module.exports = __webpack_public_path__ + "pix.svg?90f26310afd08045d3268c69e92bd994";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/pix.svg
// module id = 1127
// module chunks = 2